export default __webpack_public_path__ + "static/reviews-ccc2c0eb7f1d7032da8d7c5f4e2ac7b8.png";